<template>
  <div id="tab_benchmarks" class="tab-pane fade in active">
    <div class="tab__header">Hearing Aid Patient Cycle</div>
    <Comparisons></Comparisons>
    <div class="kpi-benchmarks-cycle">
      <div class="tab__sub-header">Crucial Events Leading to Purchase in Practices</div>
      <img class="kpi-benchmarks-cycle__image" src="/images/audiology_patient_cycle.svg" />
    </div>

    <div class="panel grid">
      <div class="grid__col--12">
        <ul class="nav nav-tabs nav-flat-bottom" style="text-align: center">
          <li class="nav-item"><a href="#pre-purchase-metrics" class="nav-link btn btn-default btn-round btn-200">Pre-Purchase Metrics</a></li>
          <li class="nav-item"><a href="#conversion-metrics" class="nav-link btn btn-default btn-round btn-200">Conversion Metrics</a></li>
          <li class="nav-item"><a href="#productivity-metrics" class="nav-link btn btn-default btn-round btn-200">Productivity Metrics</a></li>
          <li class="nav-item"><a href="#kpi-metrics" class="nav-link btn btn-default btn-round btn-200">KPIs</a></li>
        </ul>
      </div>
    </div>

    <table class="kpi-benchmarks-table">
      <tr>
        <th rowspan="2" class="header--name kpi-benchmarks-table__endColGroup">Metric Name</th>
        <th rowspan="2" class="header--benchmark-low">LOW<br>(Bottom 20%)</th>
        <th rowspan="2" class="header--benchmark-median">Median</th>
        <th rowspan="2" class="header--benchmark-high kpi-benchmarks-table__endColGroup">HIGH<br>(Top 20%)</th>
        <th colspan="2" class="header--your-practice kpi-benchmarks-table__halfHeader kpi-benchmarks-table__endColGroup">Your Practice</th>
        <th colspan="2" class="header--plus-minus kpi-benchmarks-table__endColGroup">+/- Median</th>
        <th rowspan="2" class="header--comments">Comments</th>
      </tr>
      <tr>
        <th class="header--py kpi-benchmarks-table__halfHeader">Prior YTD</th>
        <th class="header--cy kpi-benchmarks-table__halfHeader kpi-benchmarks-table__endColGroup">Current YTD</th>
        <th class="header--plus-minus-closest kpi-benchmarks-table__halfHeader">~</th>
        <th class="header--plus-minus-diff kpi-benchmarks-table__halfHeader kpi-benchmarks-table__endColGroup">Diff</th>
      </tr>
      <TableSubHead title="Pre-Purchase Metrics" anchor="pre-purchase-metrics"></TableSubHead>
      <template v-for="(metric, index) in benchPrePurchaseMetrics">
        <TableRowHead :name="metric.name"></TableRowHead>
        <component v-bind:is="getComponentName(metric.field, 'monthly')" :metric="metric"></component>
        <component v-bind:is="getComponentName(metric.field, 'annually')" :metric="metric"></component>
      </template>

      <TableSubHead title="Conversion Metrics" anchor="conversion-metrics"></TableSubHead>
      <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in benchConversionMetrics" :key="`conversion-metrics-${metric.field}-${index}`" :metric="metric"></component>
      <template v-for="(metric, index) in benchConversionFittingMetrics">
        <component v-bind:is="getComponentName(metric.field, 'monthly')" :metric="metric" :title="`${metric.name} - Monthly`"></component>
        <component v-bind:is="getComponentName(metric.field, 'annually')" :metric="metric" :title="`${metric.name} - Annually`"></component>
      </template>

      <TableSubHead title="Productivity and Financial Metrics" anchor="productivity-metrics"></TableSubHead>
      <template v-for="(metric, index) in benchFinancialMetrics">
        <TableRowHead :name="metric.name"></TableRowHead>
        <component v-bind:is="getComponentName(metric.field, 'monthly')" :metric="metric"></component>
        <component v-bind:is="getComponentName(metric.field, 'annually')" :metric="metric"></component>
      </template>

      <TableSubHead title="KPIs" anchor="kpi-metrics"></TableSubHead>
      <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in benchKpiMetrics" :key="`kpi-metrics-${metric.field}-${index}`" :metric="metric"></component>
    </table>

  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Comparisons from './Comparisons.vue';
  import TableSubHead from './benchmarks/TableSubHead.vue';
  import TableRowBase from './benchmarks/table-rows/TableRowBase.vue';
  import TableRowHead from './benchmarks/table-rows/TableRowHead.vue';
  import TableRowBaseMonthly from './benchmarks/table-rows/monthly/TableRowBase.vue';
  import TableRowBaseAnnually from './benchmarks/table-rows/annually/TableRowBase.vue';
  import TableRowNumAudiogramsByPhysicianMonthly from './benchmarks/table-rows/monthly/TableRowNumAudiogramsByPhysician.vue';
  import TableRowNumAudiogramsByPhysicianAnnually from './benchmarks/table-rows/annually/TableRowNumAudiogramsByPhysician.vue';
  import TableRowNumAudiogramsByAudiologistMonthly from './benchmarks/table-rows/monthly/TableRowNumAudiogramsByAudiologist.vue';
  import TableRowNumAudiogramsByAudiologistAnnually from './benchmarks/table-rows/annually/TableRowNumAudiogramsByAudiologist.vue';
  import TableRowHaOpportunitiesByAudiologistMonthly from './benchmarks/table-rows/monthly/TableRowHaOpportunitiesByAudiologist.vue';
  import TableRowHaOpportunitiesByAudiologistAnnually from './benchmarks/table-rows/annually/TableRowHaOpportunitiesByAudiologist.vue';
  import TableRowPercentAudiosConvertedToOpportunity from './benchmarks/table-rows/TableRowPercentAudiosConvertedToOpportunity.vue';
  import TableRowNumAudiosToGenerateOpportunity from './benchmarks/table-rows/TableRowNumAudiosToGenerateOpportunity.vue';
  import TableRowNumAudiosToGeneratePurchase from './benchmarks/table-rows/TableRowNumAudiosToGeneratePurchase.vue';
  import TableRowNumOpportunitiesToGeneratePurchase from './benchmarks/table-rows/TableRowNumOpportunitiesToGeneratePurchase.vue';
  import TableRowHaeConversionRate from './benchmarks/table-rows/TableRowHaeConversionRate.vue';
  import TableRowHearingAidUnitsPerPatient from './benchmarks/table-rows/TableRowHearingAidUnitsPerPatient.vue';
  import TableRowHearingAidUnitsPerPatientMonthly from './benchmarks/table-rows/monthly/TableRowHearingAidUnitsPerPatient.vue';
  import TableRowHearingAidUnitsPerPatientAnnually from './benchmarks/table-rows/annually/TableRowHearingAidUnitsPerPatient.vue';
  import TableRowNumHaFittingsByAudiologistMonthly from './benchmarks/table-rows/monthly/TableRowNumHaFittingsByAudiologist.vue';
  import TableRowNumHaFittingsByAudiologistAnnually from './benchmarks/table-rows/annually/TableRowNumHaFittingsByAudiologist.vue';
  import TableRowNetHaUnitsByAudiologistMonthly from './benchmarks/table-rows/monthly/TableRowNetHaUnitsByAudiologist.vue';
  import TableRowNetHaUnitsByAudiologistAnnually from './benchmarks/table-rows/annually/TableRowNetHaUnitsByAudiologist.vue';
  import TableRowNetHearingAidRevenueByAudiologistMonthly from './benchmarks/table-rows/monthly/TableRowNetHearingAidRevenueByAudiologist.vue';
  import TableRowNetHearingAidRevenueByAudiologistAnnually from './benchmarks/table-rows/annually/TableRowNetHearingAidRevenueByAudiologist.vue';
  import TableRowNetHearingAidGrossMarginByAudiologistMonthly from './benchmarks/table-rows/monthly/TableRowNetHearingAidGrossMarginByAudiologist.vue';
  import TableRowNetHearingAidGrossMarginByAudiologistAnnually from './benchmarks/table-rows/annually/TableRowNetHearingAidGrossMarginByAudiologist.vue';
  import TableRowAvgSellingPricePostDisc from './benchmarks/table-rows/TableRowAvgSellingPricePostDisc.vue';
  import TableRowAvgPatientNetRev from './benchmarks/table-rows/TableRowAvgPatientNetRev.vue';
  import TableRowCostPerUnit from './benchmarks/table-rows/TableRowCostPerUnit.vue';
  import TableRowMarginPerUnit from './benchmarks/table-rows/TableRowMarginPerUnit.vue';
  import TableRowMarginPerPatient from './benchmarks/table-rows/TableRowMarginPerPatient.vue';
  import TableRowCogPercent from './benchmarks/table-rows/TableRowCogPercent.vue';
  import TableRowGrossMarginPerNetHaRev from './benchmarks/table-rows/TableRowGrossMarginPerNetHaRev.vue';
  import TableRowBinauralRate from './benchmarks/table-rows/TableRowBinauralRate.vue';
  import TableRowUnitRefundRate from './benchmarks/table-rows/TableRowUnitRefundRate.vue';
  import TableRowAudiologistToPhysicianRatio from './benchmarks/table-rows/TableRowAudiologistToPhysicianRatio.vue';

  export default {
    name: 'Benchmarks',
    components: {
      Comparisons,
      TableSubHead,
      TableRowBase,
      TableRowHead,
      TableRowBaseMonthly,
      TableRowBaseAnnually,
      TableRowNumAudiogramsByPhysicianMonthly,
      TableRowNumAudiogramsByPhysicianAnnually,
      TableRowNumAudiogramsByAudiologistMonthly,
      TableRowNumAudiogramsByAudiologistAnnually,
      TableRowHaOpportunitiesByAudiologistMonthly,
      TableRowHaOpportunitiesByAudiologistAnnually,
      TableRowPercentAudiosConvertedToOpportunity,
      TableRowNumAudiosToGenerateOpportunity,
      TableRowNumAudiosToGeneratePurchase,
      TableRowNumOpportunitiesToGeneratePurchase,
      TableRowHaeConversionRate,
      TableRowHearingAidUnitsPerPatient,
      TableRowHearingAidUnitsPerPatientMonthly,
      TableRowHearingAidUnitsPerPatientAnnually,
      TableRowNumHaFittingsByAudiologistMonthly,
      TableRowNumHaFittingsByAudiologistAnnually,
      TableRowNetHaUnitsByAudiologistMonthly,
      TableRowNetHaUnitsByAudiologistAnnually,
      TableRowNetHearingAidRevenueByAudiologistMonthly,
      TableRowNetHearingAidRevenueByAudiologistAnnually,
      TableRowNetHearingAidGrossMarginByAudiologistMonthly,
      TableRowNetHearingAidGrossMarginByAudiologistAnnually,
      TableRowAvgSellingPricePostDisc,
      TableRowAvgPatientNetRev,
      TableRowCostPerUnit,
      TableRowMarginPerUnit,
      TableRowMarginPerPatient,
      TableRowCogPercent,
      TableRowGrossMarginPerNetHaRev,
      TableRowBinauralRate,
      TableRowUnitRefundRate,
      TableRowAudiologistToPhysicianRatio,
    },
    computed: {
      ...mapGetters('audiologyKpis', [
        'benchPrePurchaseMetrics',
        'benchConversionMetrics',
        'benchConversionFittingMetrics',
        'benchFinancialMetrics',
        'benchKpiMetrics',
      ]),
    },
    data() {
      return {
        benchCustomComponents: [
          'num_audiograms_by_physician',
          'num_audiograms_by_audiologist',
          'ha_opportunities_by_audiologist',
          'percent_audios_converted_to_opportunity',
          'num_audios_to_generate_opportunity',
          'num_audios_to_generate_purchase',
          'num_opportunities_to_generate_purchase',
          'hae_conversion_rate',
          'hearing_aid_units_per_patient',
          'num_ha_fittings_by_audiologist',
          'net_ha_units_by_audiologist',
          'net_hearing_aid_revenue_by_audiologist',
          'net_hearing_aid_gross_margin_by_audiologist',
          'avg_selling_price_post_disc',
          'avg_patient_net_rev',
          'cost_per_unit',
          'margin_per_unit',
          'margin_per_patient',
          'cog_percent',
          'gross_margin_per_net_ha_rev',
          'binaural_rate',
          'unit_refund_rate',
          'audiologist_to_physician_ratio',
        ],
      };
    },
    methods: {
      getComponentName(field, type = '') {
        if (this.benchCustomComponents.includes(field)) {
          return `TableRow${lodash.chain(field).camelCase().upperFirst().value()}${lodash.capitalize(type)}`;
        }
        return `TableRowBase${lodash.capitalize(type)}`;
      },
    },
  };
</script>
